import { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { useUIStore } from "@/stores/ui-store";
import { cn } from "@/lib/utils";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const sidebarCollapsed = useUIStore((s) => s.sidebarCollapsed);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />

      {/* Main content area - adjusts based on sidebar state */}
      <div
        className={cn(
          "transition-all duration-300",
          sidebarCollapsed ? "pl-16" : "pl-64",
        )}
      >
        {/* Page content */}
        <main className="min-h-screen">
          <div className="mx-auto max-w-7xl">{children}</div>
        </main>
      </div>
    </div>
  );
}
